import type { HTMLAttributes, PropsWithChildren } from 'react'

import clsx from 'clsx'
import { useCurrent } from 'features/campaigns/hooks'
import { appDay } from 'shared/day'

import { AccentFlow } from '../Row/Status'
import css from './Overview.module.css'

const propertyToReadableDate = (value?: null | string) =>
	value ? appDay(value).format('DD MMM YYYY HH:mm') : '—'

const AccentDD = ({ children }: PropsWithChildren) => (
	<dd className={clsx(css.accent, children === '—' && css.empty)}>
		{children}
	</dd>
)

export function Overview({ className }: HTMLAttributes<HTMLDListElement>) {
	const { campaign } = useCurrent()

	if (!campaign) {
		return null
	}

	return (
		<dl className={clsx(css.list, className)}>
			<dt className={css.title}>Status</dt>
			<dd className={css.value}>
				<AccentFlow {...campaign} />
			</dd>

			<dt className={css.title}>Contacts</dt>
			<AccentDD>{campaign.target_audience_count ?? '—'}</AccentDD>

			<dt className={css.title}>Start date</dt>
			<AccentDD>{propertyToReadableDate(campaign.started)}</AccentDD>

			<dt className={css.title}>End date</dt>
			<AccentDD>{propertyToReadableDate(campaign.completed)}</AccentDD>
		</dl>
	)
}
